export default {
    selector: '.f-four-cols-clients-slider',
    infinite: true,
    args: {
        accessibility: true,
        resize: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        percentPosition: true,
        setGallerySize: true,
        rightToLeft: true,
        draggable: false
    }
}